export default function (formatMessage: Function) {
  return {
    terminateReasonOptions: [
      {
        value: "won",
        name: formatMessage({
          id: "terminate_reason_won",
          defaultMessage: "vinto",
        }),
      },
      {
        value: "lost",
        name: formatMessage({
          id: "terminate_reason_lost",
          defaultMessage: "perso",
        }),
      },
      {
        value: "incomplete",
        name: formatMessage({
          id: "terminate_reason_incomplete",
          defaultMessage: "incompleto",
        }),
      },
    ],
  };
}
